import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=5a1ee112&scoped=true"
import script from "./SystemInfo.vue?vue&type=script&lang=js"
export * from "./SystemInfo.vue?vue&type=script&lang=js"
import style0 from "./SystemInfo.vue?vue&type=style&index=0&id=5a1ee112&prod&lang=scss&scoped=true"
import style1 from "./SystemInfo.vue?vue&type=style&index=1&id=5a1ee112&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ee112",
  null
  
)

export default component.exports